/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleAnalyticsDailyMeasurementData
 */
export interface GoogleAnalyticsDailyMeasurementData {
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    integrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    propertyId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    currencyCode?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    completeness?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    fetchedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    activeUsers?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    newUsers?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    sessions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    engagedSessions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    userEngagementDuration?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    screenPageViews?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    eventCount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    keyEvents?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    transactions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsDailyMeasurementData
     */
    purchaseRevenue?: string | null;
}

/**
 * Check if a given object implements the GoogleAnalyticsDailyMeasurementData interface.
 */
export function instanceOfGoogleAnalyticsDailyMeasurementData(value: object): value is GoogleAnalyticsDailyMeasurementData {
    return true;
}

export function GoogleAnalyticsDailyMeasurementDataFromJSON(json: any): GoogleAnalyticsDailyMeasurementData {
    return GoogleAnalyticsDailyMeasurementDataFromJSONTyped(json, false);
}

export function GoogleAnalyticsDailyMeasurementDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleAnalyticsDailyMeasurementData {
    if (json == null) {
        return json;
    }
    return {
        
        'integrationId': json['integrationId'] == null ? undefined : json['integrationId'],
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'propertyId': json['propertyId'] == null ? undefined : json['propertyId'],
        'date': json['date'] == null ? undefined : json['date'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'completeness': json['completeness'] == null ? undefined : json['completeness'],
        'fetchedAt': json['fetchedAt'] == null ? undefined : json['fetchedAt'],
        'activeUsers': json['activeUsers'] === undefined ? undefined : json['activeUsers'] === null ? null : json['activeUsers'],
        'newUsers': json['newUsers'] === undefined ? undefined : json['newUsers'] === null ? null : json['newUsers'],
        'sessions': json['sessions'] === undefined ? undefined : json['sessions'] === null ? null : json['sessions'],
        'engagedSessions': json['engagedSessions'] === undefined ? undefined : json['engagedSessions'] === null ? null : json['engagedSessions'],
        'userEngagementDuration': json['userEngagementDuration'] === undefined ? undefined : json['userEngagementDuration'] === null ? null : json['userEngagementDuration'],
        'screenPageViews': json['screenPageViews'] === undefined ? undefined : json['screenPageViews'] === null ? null : json['screenPageViews'],
        'eventCount': json['eventCount'] === undefined ? undefined : json['eventCount'] === null ? null : json['eventCount'],
        'keyEvents': json['keyEvents'] === undefined ? undefined : json['keyEvents'] === null ? null : json['keyEvents'],
        'transactions': json['transactions'] === undefined ? undefined : json['transactions'] === null ? null : json['transactions'],
        'purchaseRevenue': json['purchaseRevenue'] === undefined ? undefined : json['purchaseRevenue'] === null ? null : json['purchaseRevenue'],
    };
}

export function GoogleAnalyticsDailyMeasurementDataToJSON(json: any): GoogleAnalyticsDailyMeasurementData {
    return GoogleAnalyticsDailyMeasurementDataToJSONTyped(json, false);
}

export function GoogleAnalyticsDailyMeasurementDataToJSONTyped(value?: GoogleAnalyticsDailyMeasurementData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'integrationId': value['integrationId'],
        'accountId': value['accountId'],
        'propertyId': value['propertyId'],
        'date': value['date'],
        'timeZone': value['timeZone'],
        'currencyCode': value['currencyCode'],
        'completeness': value['completeness'],
        'fetchedAt': value['fetchedAt'],
        'activeUsers': value['activeUsers'],
        'newUsers': value['newUsers'],
        'sessions': value['sessions'],
        'engagedSessions': value['engagedSessions'],
        'userEngagementDuration': value['userEngagementDuration'],
        'screenPageViews': value['screenPageViews'],
        'eventCount': value['eventCount'],
        'keyEvents': value['keyEvents'],
        'transactions': value['transactions'],
        'purchaseRevenue': value['purchaseRevenue'],
    };
}

